import type { Connection } from '../types';

// Sample connections data - replace with API data
export const SAMPLE_CONNECTIONS: Connection[] = [];

